<script>
    import {push, pop, replace} from "svelte-spa-router"
    import {environment} from "../environment.js"
    import { AccountInfoStore } from "../stores";
    
    let accountInfo = {}
    AccountInfoStore.subscribe((data) => {accountInfo = data})
    
    const sendRequestToServer = async (thisServer, thisMessage, thisContent) => {
        const response = await fetch(thisServer, {
            method: 'POST', // or 'PUT'
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({content: thisContent, message: thisMessage})
        })
        
        const output = await response.json()
    
        return output
    }
    
    let currentUsername = ""
    let currentPassword = ""
    let isLoading = false
    let formError = ""
    
    let serverResponse = ""
    
    const validateForm = () => {
        formError = ""
        
        if (!currentUsername) {
            formError = "Username is required"
            return false
        }
        
        if (!currentPassword) {
            formError = "Password is required"
            return false
        }
        
        return true
    }
    
    const loginUser = async () => {
        if (!validateForm()) return
        
        isLoading = true
        serverResponse = "Connecting to server..."
        
        try {
            let serverData = await sendRequestToServer(environment.serverURL, "login account", {
                username: currentUsername,
                password: currentPassword
            })
            
            if (serverData.serverMessage == "Login Successful") {
                accountInfo.username = currentUsername
                accountInfo.password = currentPassword
                accountInfo.loginStatus = true
                accountInfo.coins = serverData["account_info"].coins
                accountInfo.accessToken = serverData["account_info"].accessToken
    
                let patreon_email = ""
                let patreon_username = ""
    
                if (serverData["account_info"].patreon != undefined ) {
                    patreon_email = serverData["account_info"].patreon["patreon_email"]
                    patreon_username = serverData["account_info"].patreon["patreon_username"]
                }
    
                accountInfo["patreon_email"] = patreon_email
                accountInfo["patreon_username"] = patreon_username
    
                AccountInfoStore.set(accountInfo)
    
                localStorage.setItem("sugoi_username", currentUsername);
                localStorage.setItem("sugoi_password", currentPassword);
                localStorage.setItem("sugoi_coins", serverData["account_info"].coins);
                localStorage.setItem("sugoi_accessToken", serverData["account_info"].accessToken);
                localStorage.setItem("patreon_email", patreon_email);
                localStorage.setItem("patreon_username", patreon_username);
    
                replace("/Billing")
            }
            serverResponse = serverData.serverMessage
        } catch (error) {
            serverResponse = "Connection error. Please try again."
            console.error("Login error:", error)
        } finally {
            isLoading = false
        }
    }
    </script>
    
    <div class="page">
        <div class="login-container">
            <div class="logo-container">
                <img src="/inu_icon.png" alt="Sugoi Toolkit Logo" class="logo" />
                <h1>Welcome Back</h1>
            </div>
    
            <form on:submit|preventDefault={loginUser} class="login-form">
                <div class="form-group">
                    <label for="username">Username</label>
                    <input
                        id="username"
                        type="text"
                        placeholder="Enter your username"
                        bind:value={currentUsername}
                        class:error={formError === "Username is required"}
                    />
                </div>
                
                <div class="form-group">
                    <label for="password">Password</label>
                    <input
                        id="password"
                        type="password"
                        placeholder="Enter your password"
                        bind:value={currentPassword}
                        class:error={formError === "Password is required"}
                    />
                </div>
    
                {#if formError}
                    <p class="error-message">{formError}</p>
                {/if}
                
                <button type="submit" class="login-button" disabled={isLoading}>
                    {#if isLoading}
                        Logging in...
                    {:else}
                        Log In
                    {/if}
                </button>
                
                {#if serverResponse}
                    <div class="server-response" class:error={!serverResponse.includes("Successful")}>
                        {serverResponse}
                    </div>
                {/if}
            </form>
            
            <div class="register-link">
                <p>Don't have an account? <a href="#/Registration">Register here</a></p>
            </div>
        </div>
    </div>
    
    <style>
        .page {
            width: 100vw;
            height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
            display: flex;
            justify-content: center;
            align-items: center;
        }
    
        .login-container {
            width: 400px;
            background-color: white;
            border-radius: 8px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            padding: 2rem;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    
        .logo-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 1.5rem;
        }
    
        .logo {
            width: 80px;
            height: 80px;
            margin-bottom: 1rem;
        }
    
        h1 {
            font-size: 1.8rem;
            color: #333;
            margin: 0;
            font-weight: 600;
        }
    
        .login-form {
            width: 100%;
        }
    
        .form-group {
            margin-bottom: 1.2rem;
            width: 100%;
        }
    
        label {
            display: block;
            margin-bottom: 0.5rem;
            font-weight: 500;
            color: #555;
        }
    
        input {
            width: 100%;
            padding: 0.8rem;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 1rem;
            transition: border-color 0.2s;
        }
    
        input:focus {
            border-color: #4a90e2;
            outline: none;
            box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
        }
    
        input.error {
            border-color: #e74c3c;
        }
    
        .error-message {
            color: #e74c3c;
            font-size: 0.9rem;
            margin: 0.5rem 0;
        }
    
        .login-button {
            width: 100%;
            padding: 0.8rem;
            background-color: #4a90e2;
            color: white;
            border: none;
            border-radius: 4px;
            font-size: 1rem;
            font-weight: 500;
            cursor: pointer;
            transition: background-color 0.2s;
            margin-top: 0.5rem;
        }
    
        .login-button:hover {
            background-color: #3a7bc8;
        }
    
        .login-button:disabled {
            background-color: #a0c1e8;
            cursor: not-allowed;
        }
    
        .server-response {
            margin-top: 1rem;
            padding: 0.8rem;
            background-color: #f1f9f1;
            border-radius: 4px;
            font-size: 0.9rem;
            text-align: center;
            color: #2c7a2c;
        }
    
        .server-response.error {
            background-color: #fdf1f0;
            color: #e74c3c;
        }
    
        .register-link {
            margin-top: 1.5rem;
            text-align: center;
            font-size: 0.9rem;
            color: #666;
        }
    
        .register-link a {
            color: #4a90e2;
            text-decoration: none;
            font-weight: 500;
        }
    
        .register-link a:hover {
            text-decoration: underline;
        }
    </style>